import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material";
import { ExcelService, Combo2Service, ComboService } from "../../../services/index";
import { SalesOrderService } from "../../../services/salesOrder.service";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import swal from "sweetalert2";

@Component({
  selector: "sales-order-cancel",
  templateUrl: "salesOrderCancel.html",
})
export class salesOrderCancel implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  isLoadMask: Promise<any>;
  loadingIndicator: boolean;
  gridOptions: any;
  IsWait: boolean = false;
  exceldata: any;
  curDate = new Date();
  party_name = [""];
  colorList = [
    "#FFE4E1",
    "#F0FFF0",
    "#F5FFFA",
    "#F0FFFF",
    "#F0F8FF",
    "#FAEBD7",
    "#F5F5F5",
    "#FFF5EE",
    "#F5F5DC",
    "#FAF0E6"
  ];

  filter = {
    party_id: "",
    from_date: "",
    to_date: "",
    newDesignShade: "",
    shade: "",
    groupby: "party_wise",
    so_date:"",
    so_no:"",
    party_name: "",
    so_id: "",
    status: ""
  };
  columns = [];
  excelColumns = [];
  toggleCol = [];
  newDesignList = [];
  statusList= ["Hold"]
  partyList = [];
  totalList = {
  total_ord:  0,
  total_dlry:  0,
  total_pend: 0,
  };

  SalesCancelOrder: any;
  stockOrder: any;
  totalOrderPend: any;

  constructor(
    private salesOrderServ: SalesOrderService,
    private spin: MatProgressSpinnerModule,
    private excelService: ExcelService,
    private combo: Combo2Service,
    public datePipe: DatePipe,
    public comboservice: ComboService

  ) {
    let from_date =
      this.curDate.getFullYear() +
      "-" +
      this.curDate.getMonth() +
      "-" +
      this.curDate.getDate(),
      to_date =
        this.curDate.getFullYear() +
        "-" +
        (this.curDate.getMonth() + 1) +
        "-" +
        this.curDate.getDate();

    this.filter.from_date = this.datePipe.transform(from_date, "yyyy-MM-dd");
    this.filter.to_date = this.datePipe.transform(to_date, "yyyy-MM-dd");
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    this.getPartyList();
    this.getColumns();
    this.getSalesOrderCancelAndPend();

    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

  }
  pageCallback() {
    this.getSalesOrderCancelAndPend();
  }

  onPrevClick() {
    if (this.filter.groupby == "designColor") {
      this.filter.groupby = "design";
      this.filter.so_id = '';
      this.filter.newDesignShade = "";
      this.filter.so_date = "";
      this.filter.so_no = "";
    }
      else if(this.filter.groupby == "design"){
        this.filter.groupby ="party_wise";
        this.filter.party_id = "";
        this.filter.party_name ="";
      }
    this.getSalesOrderCancelAndPend();
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }
  onSelectParty(party) {
    this.partyList.forEach((element) => {
      if (party == element.name) {
        this.filter.party_id = element.genLedid;
      }
    });

  this.SalesCancelOrder = this.SalesCancelOrder.filter(e=> e.party_id == this.filter.party_id);
  this.totSo();
  }
  clearFilter(){
    this.filter.party_id = "";
    this.filter.party_name = "";
    this.filter.status= "";
    this.getSalesOrderCancelAndPend();
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  getSalesOrderCancelAndPend() {
    this.IsWait = true;
    if (this.filter.party_id == "") {
      this.filter.groupby = "party_wise";
    }
    else if (this.filter.newDesignShade == "") {
      this.filter.groupby = "design";
    }
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    let params = {
      filter: JSON.stringify(this.filter),
    };

    let that = this;

    that.gridOptions = {
      loading: true,
      columns: [],
    };
    that.salesOrderServ.getSalesOrderCancelAndPend(params).then((res: any) => {
      this.IsWait = false;
      that.SalesCancelOrder = res.orderPenArr;
      let temp = 0;
      that.SalesCancelOrder.forEach((el, ind) => {
          if (ind >= 10) {
            temp = temp + 1;
            if (temp == 10) {
             temp = 0;
            }
            el.background = that.colorList[temp];
          }
          else {  
            el.background = that.colorList[ind];
          }
        });
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };

      if (that.filter.groupby == "designColor") {
        that.SalesCancelOrder = that.SalesCancelOrder.sort(
          (a, b) => parseFloat(a.shade) - parseFloat(b.shade)
        );
      }
      this.totSo();
    });
  }
  totSo() {
    let that = this;
    that.totalList.total_ord = 0;
    that.totalList.total_dlry = 0;
    that.totalList.total_pend = 0;
    that.SalesCancelOrder.forEach((el) => {
      that.totalList.total_ord += Number(el.ord_pcs);
      that.totalList.total_dlry += Number(el.dlry_pcs);
      that.totalList.total_pend += Number(el.tot);
      el.ord_pcs = el.ord_pcs;
    });
    that.totalList.total_ord =
      Math.round(((that.totalList.total_ord + Number.EPSILON) * 100) / 100);
  }
  onDesignClick(SOC: any, event: any) {
    if (event.target.checked == undefined) {
      if(this.filter.groupby == "party_wise"){
        this.filter.party_id = this.SalesCancelOrder[SOC].party_id;
        this.filter.party_name = this.SalesCancelOrder[SOC].party_name;
      }
      else if (this.filter.groupby == "design") {
        this.filter.groupby = "designColor";
        this.filter.newDesignShade = this.SalesCancelOrder[SOC].design_no;
        this.filter.so_id = this.SalesCancelOrder[SOC].so_id;
        this.filter.so_date = this.SalesCancelOrder[SOC].so_date;
        this.filter.so_no = this.SalesCancelOrder[SOC].so_no;
      } 
      // else if (this.filter.groupby == "designColor") {
      //   // this.filter.groupby = "designColorOrder";
      //   this.filter.newDesignShade = this.SalesCancelOrder[SOC].design_no;
      //   this.filter.shade = SOC.shade;
      //   this.filter.so_id = '';
      // }
      this.getSalesOrderCancelAndPend();
    } else if (event.target.checked != undefined) {
      this.SalesCancelOrder[SOC].is_selected = event.target.checked;
    }
  }
  CheckedAllSo(event: any) {
    console.log(event.target.checked, "check Event")
    this.SalesCancelOrder = this.SalesCancelOrder.map(item => ({
      ...item,
      is_selected: event.target.checked
    }));
    console.log(event.target.checked, this.SalesCancelOrder)
  }
  deleteRow() {  
    let params: any = Object.assign({}, this.filter);
    params["tabevent"] = undefined;
      let cancel = this.SalesCancelOrder.filter((CSO:any) => CSO.is_selected == true);
    params["soGrid"] = JSON.stringify(cancel);
    let that = this;

  if(cancel.length) {

    // Build the HTML conditionally
let reasonDropdown = '';
    if (this.filter.status != 'Hold') {
      reasonDropdown =
        '<select id="reason" class="swal2-input" style="display: block; margin: 10px auto; padding: 10px; border: 1px solid #d9d9d9; border-radius: 3px; width: 300px;">' +
        '<option value=""></option>' +
        '<option value="Stop Order">Stop Order</option>' +
        '<option value="Hold">Hold</option>' +
        '</select>';
    }
     swal({
  title: "Are you sure to Cancel this details?",
  html:
     reasonDropdown +
    '<input type="text" id="comment" class="swal2-input" placeholder="Comment">' +
    '<input type="text" id="cl_by" class="swal2-input" placeholder="NAME">' +
    '<input type="date" id="cancel_date" class="swal2-input" placeholder="DATE">',
  type: "warning",
  showCancelButton: true,
  confirmButtonText: "Yes, Proceed it!",
  cancelButtonText: "No, want to change",
}).then(function () {
  if (
    (that.filter.status !='Hold' && (<HTMLSelectElement>document.getElementById("reason")).value != "" ) || that.filter.status =='Hold'
  ) {
    params["reason"] = that.filter.status !='Hold' ? (<HTMLSelectElement>document.getElementById("reason")).value : '';
    params["cancel_comment"] = (<HTMLInputElement>document.getElementById("comment"))
      .value || '';
    params["cl_by"] = (<HTMLInputElement>document.getElementById("cl_by"))
      .value || '';
    params["cancel_date"] = (<HTMLInputElement>document.getElementById("cancel_date"))
      .value || '0000-00-00';

    that.salesOrderServ.
      updateSalesOrderCancel(params)
      .then(function (res: any) {
        let tabObj = {
          action: "CloseTab",
          params: {},
        };
        that.tabUpdateEvent.emit(tabObj);
      });
  }
});
    } else {
      swal({ 
        type: 'warning',
        title: "Select Atleast One S.No",
        showConfirmButton: true
      });
    }
  }
 

 ngOnDestroy() {
    this.salesOrderServ;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesOrderCancel/salesOrderCancel.ts